import React from 'react';
import styled from 'styled-components';

import {Paper} from 'components';

const Container = styled.div`
    background-color: var(--secondary-color);
    // width: var(--popout-width);
    width: fit-content;
    min-width: var(--popout-width);
    max-width: 17rem;
    font-size: var(--popout-font-size);
    padding: 0.5rem;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
    border: 2px solid var(--primary-accent-color);
    :focus{
        outline: none;
    }
`

const ContextMenu = props => {
    return(
        <Paper>
            <Container>
                {props.children}
            </Container>
        </Paper>
    )
}

export default ContextMenu